import useDynamicTabs from './useDynamicTabs/index.js';
export default useDynamicTabs;
